import React, { useEffect, useState } from "react";
import TransactionCard from "../components/Wallet/TransactionCard";
import * as api from "../api";
import { hardcoded_event } from "../constants";
import { ReactComponent as WalletIcon } from "../assets/images/wallet.svg";

const tabs = [
  { label: "All", fetcher: "list" },
  { label: "Spending", fetcher: "listDebits" },
  { label: "Receiving", fetcher: "listCredits" },
];

const Wallet = ({ user = {}, setShowLogin = () => {}, userLoading = false }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [balance, setBalance] = useState(null);
  const [balanceLoading, setBalanceLoading] = useState(true);

  useEffect(() => {
    if (Object.keys(user).length !== 0 && !userLoading) {
      setShowLogin(false);
    } else if (Object.keys(user).length === 0 && !userLoading) {
      setShowLogin(true);
    }
  }, [user, userLoading]);

  useEffect(() => {
    if (Object.keys(user).length === 0) return;
    setLoading(true);
    api.wallet[tabs[activeTab].fetcher]()
      .then((response) => {
        if (response.status && response.status >= 200 && response.status < 300) {
          setTransactions(response.data.results || []);
        }
      })
      .finally(() => setLoading(false));
  }, [activeTab, user]);

  useEffect(() => {
    if (Object.keys(user).length === 0 || !hardcoded_event) return;
    setBalanceLoading(true);
    api.wallet
      .getBalance()
      .then((response) => {
        if (response.status && response.status >= 200 && response.status < 300) {
          setBalance(response.data.balance);
        }
      })
      .catch(() => {})
      .finally(() => setBalanceLoading(false));
  }, [user]);

  return (
    <React.Fragment>
      {Object.keys(user).length !== 0 && (
        <div className="wallet">
          <h2 className="page-title">Wallet</h2>
          {!balanceLoading && balance !== null && (
            <div className="wallet__balance-card">
              <div className="wallet__balance-icon">
                <WalletIcon />
              </div>
              <div className="wallet__balance-info">
                <span className="wallet__balance-label">Your Balance</span>
                <span className="wallet__balance-amount">
                  {(balance / 100).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  <span className="wallet__balance-currency">EGP</span>
                </span>
              </div>
            </div>
          )}
          <div className="wallet__tabs">
            {tabs.map((tab, index) => (
              <div
                className={
                  "wallet__tab-item" +
                  (index === activeTab ? " wallet__tab-item--active" : "")
                }
                key={index}
                onClick={() => setActiveTab(index)}
              >
                {tab.label}
              </div>
            ))}
          </div>
          <div className="wallet__body">
            {loading && <p className="wallet__loading">Loading...</p>}
            {!loading && transactions.length === 0 && (
              <p className="wallet__empty">No transactions yet.</p>
            )}
            {!loading &&
              transactions.map((transaction) => (
                <TransactionCard key={transaction.pk} transaction={transaction} />
              ))}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Wallet;
